function Pagination(element) {
  this.$element = element;

  this.update = function (html) {
    this.$element.empty().append(html);
    this.bindEvents();
  };

  this.bindEvents = function () {
    this.$element.find('li>a,a.next,a.prev').on('click', function (e) {
      e.preventDefault();
      if ($(this).parents('#pagination_bottom').length) {
        $('html').scrollTop($('#pagination_top').offset().top - 80)
      }
      var href = this.getAttribute("href");
      if (href) {
        CatalogPage.pageChanged(href);
      }
    });
  };
}